<td class="file-name-cell" [ngClass]="{'file-name-too-long': isFileNameTooLong}" appFsMask>{{uploadedFile.fileItem?.file.name}}</td>
<td>
  <div class="form-input-container">
    <app-select2
      id="docTypeSelect"
      placeholder="Select Statement Type"
      [disabled]="fileUploadProcessBegun"
      [data]="uploadDocumentTypeOptions"
      [options]="{minimumResultsForSearch: -1}"
      [value]="uploadedFile.selectedType"
      (valueChanged)="updateDocType($event.value)"
      [width]="'100%'"
      [ngClass]="{'has-error': uploadedFile.error.selectedType}"
      >
    </app-select2>
    @if (uploadedFile.error.selectedType) {
      <span class="help-block error-text"
      >Please select the statement type</span>
    }

    @if (uploadedFile.selectedType === TAX_RETURN) {
      <div class="row additional-tax-form-inputs">
        <div class="col-6 sm-right-padding">
          <app-select2
            id="taxFormSelect"
            placeholder="Select Tax Form"
            [disabled]="fileUploadProcessBegun"
            [data]="taxFormOptions"
            [options]="{minimumResultsForSearch: -1}"
            [value]="uploadedFile.selectedTaxForm"
            (valueChanged)="updateTaxForm($event.value)"
            [width]="'100%'"
            [ngClass]="{'has-error': uploadedFile.error.selectedTaxForm}"
            >
          </app-select2>
          @if (uploadedFile.error.selectedTaxForm) {
            <span class="help-block error-text">Please select a tax form</span>
          }
        </div>
        <div class="col-6 sm-left-padding">
          <ng-container>
            <app-select2
              id="taxYearSelect"
              placeholder="Tax Return Year"
              [disabled]="fileUploadProcessBegun"
              [data]="taxYearOptions"
              [options]="{minimumResultsForSearch: -1}"
              [value]="uploadedFile.selectedStatementDate"
              (valueChanged)="updateTaxYear($event.value)"
              [width]="'100%'"
              [ngClass]="{'has-error': uploadedFile.error.selectedStatementDate}"
              >
            </app-select2>
            @if (uploadedFile.error.selectedStatementDate) {
              <span class="help-block error-text">Please select when the tax return year began</span>
            }
          </ng-container>
        </div>
      </div>
    }

    @for (customAttrDefinition of customAttrDefinitions; track customAttrDefinition) {
      <div class="row">
        <div class="col-12 small-top-margin">
          <div class="title">{{customAttrDefinition.name}}</div>
          <input type="text" name="{{customAttrDefinition.key}}" class="form-control"
            [disabled]="fileUploadProcessBegun"
            [ngClass]="{'has-error': uploadedFile.error.invalidCustomAttributeFields.hasOwnProperty(customAttrDefinition.key)}"
            (change)="customAttributeChange(customAttrDefinition, $event)"/>
          @if (uploadedFile.error.invalidCustomAttributeFields.hasOwnProperty(customAttrDefinition.key)) {
            <span class="help-block error-text"
              >
              {{customAttrDefinition.name}} is required
            </span>
          }
        </div>
      </div>
    }
  </div>


</td>
@if (showCombineFeature) {
  <td class="checkbox-cell">
    <input
      type="checkbox"
      [disabled]="fileUploadProcessBegun || (combineDisabled && !uploadedFile.combine)"
      [(ngModel)]="uploadedFile.combine"
      (ngModelChange)="_combineChange.emit($event)" />
  </td>
}
<td class="icon-cell">
  @switch (uploadedFile.status) {
    @case ('uploaded') {
      <i class="fa fa-trash-alt" [ngClass]="{'disabled': fileUploadProcessBegun}"
      (click)="!fileUploadProcessBegun ? removeFile() : null"></i>
    }
    @case ('submitting') {
      <div class="loader"></div>
    }
    @case ('submission_complete') {
      <i class="fa fa-check"></i>
    }
    @case ('error') {
      <i class="fa fa-xmark"></i>
    }
  }
</td>
